import axios from 'axios'
import { fnCleanStorage } from '../contexts/Auth';
import { useParams } from 'react-router-dom';

const getAuthorizationAccessToken = () => {
    return localStorage?.getItem("cAccessToken") || null;
}
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
})

api.interceptors.request.use(
    async (req) => {
        const authToken = getAuthorizationAccessToken();

        if (authToken) req.headers.Authorization = `Bearer ${authToken}`;

        return req;
    },
    (err) => {
        console.log("err", err)
        return Promise.reject(err);
    }
);

api.interceptors.response.use(
    (res) => {
        const bQrCodeLink = localStorage.getItem("qrCodeUrl")
        if (bQrCodeLink && localStorage.getItem("qrCodeUrl")) {

            window.location.href = bQrCodeLink
            localStorage.removeItem("qrCodeUrl")
        }
        return res;
    },
    (err) => {
        if (err?.request?.status === 401) {
            fnCleanStorage()
            if (window.location.pathname !== "/") {
                window.location.href = "/";
            }
        }
        return Promise.reject(err);
    }
);

export default api;